export enum CalendarProvider {
    Google = 'Google',
}
